export const CLIENT_LOGOS = [
  { name: 'Ленкабель', logo: '/images/logos/lenkabel.png' },
  { name: 'Pragmatica', logo: '/images/logos/pragmatica.svg' },
  { name: 'Сбербанк', logo: '/images/logos/sberbank.png' },
  { name: 'Ozon', logo: '/images/logos/ozon.png' },
  { name: 'VK', logo: '/images/logos/vk.png' },
  { name: 'Яндекс', logo: '/images/logos/yandex.svg' },
  { name: 'Pizza Hut Russia', logo: '/images/logos/pizza-hut.png' },
  { name: 'YIT', logo: '/images/logos/yit.png' },
  { name: 'Softline', logo: '/images/logos/softline.png' },
  { name: 'Marvel Дистрибуция', logo: '/images/logos/marvel.jpg' },
  { name: 'Lanit', logo: '/images/logos/lanit.png' },
  { name: 'Газпром-Нефть', logo: '/images/logos/gazprom-neft.png' },
  { name: 'Газпромбанк', logo: '/images/logos/gazprombank.png' },
  { name: 'Takeda', logo: '/images/logos/takeda.svg' },
  { name: 'ОМК', logo: '/images/logos/omk.jpg' },
];
